import React from "react";
import Cleave from "cleave.js/react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const NumberField = (props: any) => {
  const { placeholder, value, register, errors, label, setValue, clearErrors } =
    props;
  return (
    <div className={tw`w-full my-2 text-left mt-4`}>
      <label htmlFor="">{label}</label>
      <Cleave
        type="text"
        className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        placeholder={placeholder}
        value={value}
        autoComplete="off"
        onBlur={(e) => clearErrors(register.name)}
        onChange={(e) => setValue(register.name, e.target.value)}
        disabled={register.disabled}
        options={{
          numeral: true,
          numeralDecimalMark: ".",
          numeralDecimalScale: 0,
          numeralPositiveOnly: true,
          delimiter: "",
        }}
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default NumberField;
